/**
 * Values that vary down a list so the bars read as text, not a table. Cycles
 * the given values by row; the fallback only exists for the type checker.
 */
export function cycle<T>(values: readonly T[], fallback: T): (i: number) => T {
  return i => values[i % values.length] ?? fallback
}
